import { PropsWithChildren, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useUserStore } from '@/configs/store';
import { UserRole } from '@/types/user';

type Props = PropsWithChildren<{
  roles: UserRole[];
  redirectTo?: string;
  loadingFallback?: ReactNode;
}>;

export const RoleGuard = ({ roles = [], children, redirectTo, loadingFallback }: Props) => {
  const { isLoading, user } = useUserStore();
  const location = useLocation();

  if (isLoading) {
    return loadingFallback || null;
  }

  const hasAccess = user && roles.some((role) => user.roles.includes(role));

  if (!hasAccess) {
    if (redirectTo) {
      return <Navigate to={redirectTo} state={{ from: location }} replace />;
    }

    return null;
  }

  return children;
};
